module.exports = __webpack_public_path__ + "img/BizLink.55ff8098.png";